module.exports = __webpack_public_path__ + "static/media/thumbnail.4763f8d0.jpg";